var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElement4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 9.08329V3.41663C18.3333 2.16663 17.8 1.66663 16.475 1.66663H13.1083C11.7833 1.66663 11.25 2.16663 11.25 3.41663V9.08329C11.25 10.3333 11.7833 10.8333 13.1083 10.8333H16.475C17.8 10.8333 18.3333 10.3333 18.3333 9.08329Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 16.5834V15.0834C18.3333 13.8334 17.8 13.3334 16.475 13.3334H13.1083C11.7833 13.3334 11.25 13.8334 11.25 15.0834V16.5834C11.25 17.8334 11.7833 18.3334 13.1083 18.3334H16.475C17.8 18.3334 18.3333 17.8334 18.3333 16.5834Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74984 10.9166V16.5833C8.74984 17.8333 8.2165 18.3333 6.8915 18.3333H3.52484C2.19984 18.3333 1.6665 17.8333 1.6665 16.5833V10.9166C1.6665 9.66663 2.19984 9.16663 3.52484 9.16663H6.8915C8.2165 9.16663 8.74984 9.66663 8.74984 10.9166Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74984 3.41663V4.91663C8.74984 6.16663 8.2165 6.66663 6.8915 6.66663H3.52484C2.19984 6.66663 1.6665 6.16663 1.6665 4.91663V3.41663C1.6665 2.16663 2.19984 1.66663 3.52484 1.66663H6.8915C8.2165 1.66663 8.74984 2.16663 8.74984 3.41663Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement4);
export default __webpack_public_path__ + "static/media/element-4.a074d8c1c0db82d89373088cff146a29.svg";
export { ForwardRef as ReactComponent };